import { ACTION_TYPE } from "../constants";

export const updateMousePosition = (x, y) => {
  return { type: ACTION_TYPE.UPDATE_MOUSE_POSITION, payload: { x, y } };
};

export const updateMouseDown = isMouseDown => {
  return { type: ACTION_TYPE.UPDATE_MOUSE_DOWN, payload: { isMouseDown } };
};
